import { useQuery } from "@tanstack/react-query";
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import { AuthClient, Token, UserProfileResult } from "./apiClient";
import axios from "./axiosInstance";

const authClient = new AuthClient(undefined, axios);

createAuthRefreshInterceptor(axios, (failedRequest): Promise<any> => {
  console.log('refreshing token...');

  // TODO: add a refresh endpoint
  return axios.get('/api/auth/token').then((response: any) => {
    console.log('refreshing token...success!');

    localStorage.setItem("accessToken", response.accessToken || "");
    failedRequest.response.config.headers.Authorization = 'Bearer ' + response.accessToken;

    return Promise.resolve();
  }).catch((error) => {
    console.log('refreshing token...failed!');

    /*
    if (window.location.pathname !== "/") {
      setTimeout(() => {
        window.location.href = "/";
      }, 0);
    }
    */

    return Promise.reject(error);
  });
},
  {
    shouldRefresh: (error: any) => {
      console.log('shouldRefresh token!', error);

      if (error.config?.url === '/api/auth/token') {
        return false;
      }
      if (error.config?.url === '/logout') {
        return false;
      }
      if (error.response?.status === 401) {
        return true;
      }
      return false;
    }
  });

/*
createAuthRefreshInterceptor(axios, (failedRequest): Promise<any> => {
  console.log('refreshing token...');

  return authClient.getUserProfile().then((response) => {
    console.log('refreshing token...success!');

    localStorage.setItem("accessToken", response.accessToken || "");
    failedRequest.response.config.headers['Authorization'] = 'Bearer ' + response.accessToken;

    return Promise.resolve();
  }, (error) => {
    console.log('refreshing token...failed!');

    if (window.location.pathname !== "/") {
      return (window.location.href = "/");
    }
        
    return Promise.reject();
  });
});
*/

export const useUserProfile = (options?: any) => {
  return useQuery<UserProfileResult>({
    ...options,
    queryKey: ["userProfile"],
    retry: 0,
    queryFn: async () => authClient.getUserProfile(),
  });
};


export const useAuthToken = (options?: any) => {
  return useQuery<UserProfileResult>({
    ...options,
    queryKey: ["authToken"],
    retry: 0,
    queryFn: async () => authClient.getUserProfile2(),
  });
};

export const useViewToken = (options?: any) => {
  return useQuery<Token>({
    ...options,
    queryKey: ["viewToken"],
    queryFn: async () => authClient.createViewToken(),
  });
};
